import React from "react";
import TransactionForm from "../../../components/Forms/TransactionForm/TransactionForm";
import { useLocation } from "react-router-dom";
import "./Transaction.scss";

const Transaction = (props) =>  {
    const location = useLocation();
    // const customer = location.state;
    return (
        <>
            <section className="form__container">
                <h1>Transaction</h1>
                <div className="form__container-wrapper">
                    <TransactionForm/>
                </div>
            </section>
            
        </>
    );
}

export default Transaction;